import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useTheme } from "@mui/material/styles";
import { Box } from "../Box/index.js";
import { Typography } from "../Typography/index.js";
import { Icon } from "../Icon/index.js";
const Callout = (t0)=>{
    const $ = c(26);
    const { bordered: t1, children, title, showIcon: t2, withBackground: t3, variant: t4, expanded: t5, size: t6 } = t0;
    const bordered = void 0 === t1 ? false : t1;
    const showIcon = void 0 === t2 ? true : t2;
    const withBackground = void 0 === t3 ? true : t3;
    const variant = void 0 === t4 ? "primary" : t4;
    const expanded = void 0 === t5 ? false : t5;
    const size = void 0 === t6 ? "medium" : t6;
    const theme = useTheme();
    let t7;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = {
            error: "error_circle_outline",
            warning: "error_circle_outline",
            primary: "info_circle_outline",
            paper: "info_circle_outline"
        };
        $[0] = t7;
    } else t7 = $[0];
    const iconName = t7;
    let t8;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            error: "accent.text.error",
            warning: "accent.text.warning",
            primary: "stroke.primary",
            paper: "stroke.primary"
        };
        $[1] = t8;
    } else t8 = $[1];
    const borderColor = t8;
    let t9;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            error: "accent.bg.error",
            warning: "accent.bg.warning",
            primary: "bg.greyscale.primary",
            paper: "bg.light.primary"
        };
        $[2] = t9;
    } else t9 = $[2];
    const bgColor = t9;
    let t10;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = {
            error: "accent.text.error",
            warning: "accent.text.warning",
            primary: "text.light.primary",
            paper: "text.light.primary"
        };
        $[3] = t10;
    } else t10 = $[3];
    const color = t10;
    let t11;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = {
            error: "accent.text.error",
            warning: "accent.text.warning",
            primary: "original.brand.primary",
            paper: "original.brand.primary"
        };
        $[4] = t11;
    } else t11 = $[4];
    const iconColor = t11;
    let t12;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = {
            small: "16",
            medium: "24",
            large: "32",
            none: "0"
        };
        $[5] = t12;
    } else t12 = $[5];
    const expandedPaddingBySize = t12;
    let t13;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = {
            small: "12",
            medium: "16",
            large: "24",
            none: "0"
        };
        $[6] = t13;
    } else t13 = $[6];
    const paddingXBySize = t13;
    let t14;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = {
            small: "4",
            medium: "8",
            large: "16",
            none: "0"
        };
        $[7] = t14;
    } else t14 = $[7];
    const paddingYBySize = t14;
    let t15;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = {
            small: "subtitle2",
            medium: "subtitle1",
            large: "h6",
            none: "body2"
        };
        $[8] = t15;
    } else t15 = $[8];
    const typographyTitleVariant = t15;
    const t16 = withBackground ? bgColor[variant] : void 0;
    const t17 = "large" === size ? "l" : "m";
    const t18 = bordered ? "1px solid" : "none";
    const t19 = withBackground ? borderColor[variant] : borderColor.primary;
    const t20 = withBackground ? color[variant] : color.primary;
    const t21 = expanded ? expandedPaddingBySize[size] : paddingXBySize[size];
    const t22 = expanded ? expandedPaddingBySize[size] : paddingYBySize[size];
    let t23;
    if ($[9] !== children || $[10] !== expanded || $[11] !== showIcon || $[12] !== size || $[13] !== theme || $[14] !== title || $[15] !== variant) {
        t23 = expanded ? /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            children: [
                /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    alignItems: "center",
                    mb: "8",
                    children: [
                        showIcon && /*#__PURE__*/ jsx(Box, {
                            mr: "small" === size ? "8" : "12",
                            display: "flex",
                            alignItems: "center",
                            alignSelf: "flex-start",
                            color: color[variant],
                            children: /*#__PURE__*/ jsx(Icon, {
                                name: iconName[variant],
                                size: "20",
                                color: iconColor[variant],
                                "data-testid": "icon"
                            })
                        }),
                        title && /*#__PURE__*/ jsx(Typography, {
                            variant: typographyTitleVariant[size],
                            children: title
                        })
                    ]
                }),
                /*#__PURE__*/ jsx(Box, {
                    display: "flex",
                    alignItems: "center",
                    fontSize: "large" === size ? theme.tokens.typography.variant.body2.fontSize : theme.tokens.typography.variant.body3.fontSize,
                    children: children
                })
            ]
        }) : /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "flex-start",
            children: [
                showIcon && /*#__PURE__*/ jsx(Box, {
                    mr: "small" === size ? "8" : "12",
                    color: color[variant],
                    display: "flex",
                    alignItems: "center",
                    children: /*#__PURE__*/ jsx(Icon, {
                        name: iconName[variant],
                        size: "20",
                        color: iconColor[variant]
                    })
                }),
                children
            ]
        });
        $[9] = children;
        $[10] = expanded;
        $[11] = showIcon;
        $[12] = size;
        $[13] = theme;
        $[14] = title;
        $[15] = variant;
        $[16] = t23;
    } else t23 = $[16];
    let t24;
    if ($[17] !== t16 || $[18] !== t17 || $[19] !== t18 || $[20] !== t19 || $[21] !== t20 || $[22] !== t21 || $[23] !== t22 || $[24] !== t23) {
        t24 = /*#__PURE__*/ jsx(Box, {
            bgcolor: t16,
            radius: t17,
            border: t18,
            borderColor: t19,
            color: t20,
            className: "aqa_callout",
            testId: "aqa_callout",
            alignItems: "flex-start",
            px: t21,
            py: t22,
            children: t23
        });
        $[17] = t16;
        $[18] = t17;
        $[19] = t18;
        $[20] = t19;
        $[21] = t20;
        $[22] = t21;
        $[23] = t22;
        $[24] = t23;
        $[25] = t24;
    } else t24 = $[25];
    return t24;
};
export { Callout };
